import { component } from 'picoapp';

export default component((node: HTMLElement) => {
  const content: HTMLElement = node.querySelector('[data-content]');
  const { offsetHeight } = content;

  const reveal: HTMLButtonElement = node.querySelector('[data-reveal]');
  const openText: HTMLSpanElement = node.querySelector('[data-open]');
  const closeText: HTMLSpanElement = node.querySelector('[data-close]');

  if (reveal && content) {
    reveal.addEventListener('click', () => {
      content.classList.toggle('is-visible');
      content.style.height = content.classList.contains('is-visible') ? `${content.scrollHeight}px` : `${offsetHeight}px`;

      openText.classList.toggle('hidden');
      closeText.classList.toggle('hidden');
    });
  }
});
